export enum SalaryTypes {
  RANGE = 1,
  FIXED = 2,
}
